module.exports = __webpack_public_path__ + "static/img/i8en.470aca4.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/theme/light/article/iosMessageSet/i8en.png
// module id = gN/8
// module chunks = 0